import { render, staticRenderFns } from "./SopportunityCreate.vue?vue&type=template&id=be0b8c36&scoped=true"
import script from "./SopportunityCreate.vue?vue&type=script&lang=js"
export * from "./SopportunityCreate.vue?vue&type=script&lang=js"
import style0 from "./SopportunityCreate.vue?vue&type=style&index=0&id=be0b8c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0b8c36",
  null
  
)

export default component.exports